import { useMemo } from "react";

import Account from "./Account";
import Transaction from "./Transaction";

const TYPE = {
  account: Account,
  transaction: Transaction,
};

const Card = ({ subType, ...props }) => {
  const View = useMemo(() => TYPE[subType], [subType]);
  return <View {...props} />;
};

export default Card;
